import getConfig from 'next/config';

const config = getConfig();

const API_ROOT = `${config ? config.publicRuntimeConfig.apiUrl : ''}/api/v2`;

export default API_ROOT;
